import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
import { styles } from "./preview-profile.css.js";
import { appContext } from "ui-common/appContext.js";

@customElement("preview-profile")
export class PreviewProfile extends LitElement {
  static override styles = [styles];

  @property({ type: String, attribute: "page" })
  page: string = "";

  private iframeRef = createRef<HTMLIFrameElement>();

  private get iframeSrc(): string {
    if (!this.page) {
      return "";
    }

    return `${location.origin}/${appContext.currentUser?.handle}/${this.page}?preview=true`;
  }

  public reloadIframe() {
    if (this.iframeRef.value?.contentWindow) {
      this.iframeRef.value.contentWindow.location.reload();
    }
  }

  protected override render() {
    if (!this.page) {
      return html`<div class="error-message">Please provide a page attribute to preview.</div>`;
    }

    return html`
      <div class="preview-container">
        <iframe
          ${ref(this.iframeRef)}
          src=${this.iframeSrc}
          title="Preview"
          frameborder="0"
          sandbox="allow-same-origin allow-scripts"
        ></iframe>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "preview-profile": PreviewProfile;
  }
}
